import { Inject, Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { AbstractGitService, GitParentFolders, GIT_PARENT_FOLDERS } from '@y42/feature/git/state';
import { GitQuery, GitService } from '@y42/git';
import {
  VisualizationCanvasElementGitModel,
  VisualizationCanvasElementStoreModel,
} from './visualization-canvas-element.model';

@Injectable()
export class VisualizationCanvasElementGitService extends AbstractGitService<
  VisualizationCanvasElementStoreModel,
  Y42GitFolders.VisualizationDashboard
> {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
    @Inject(GIT_PARENT_FOLDERS) protected readonly parentFolders: GitParentFolders,
  ) {
    super({
      gitQuery,
      git,
      name: 'Visualization-Canvas-Element-Git',
      basePath: getY42GitPath(Y42GitFolders.VisualizationDashboard),
      errorHandlerService,
      // canvasElements are nested inside a `/canvas` folder
      // check if parentFolders' last element is "canvas", if not append it
      parentFolders:
        parentFolders?.[parentFolders.length - 1] === 'canvas' ? parentFolders : [...(parentFolders || []), 'canvas'],
    });
  }

  async create(canvasElement: VisualizationCanvasElementStoreModel) {
    const path = this.getPath(canvasElement.$name);
    await this.git.writeFile({
      path,
      content: new VisualizationCanvasElementGitModel(canvasElement),
    });
  }

  async update(canvasElement: VisualizationCanvasElementStoreModel) {
    const path = this.getPath(canvasElement.$name);
    await this.git.writeFile({
      path,
      content: new VisualizationCanvasElementGitModel(canvasElement),
    });
  }

  async delete(id: VisualizationCanvasElementStoreModel['$name']) {
    const path = this.getPath(id);
    return await this.git.deleteFile({ path });
  }
}
